import React, { useState, useEffect } from "react";
import Breadcrumb from "../components/Breadcrumb";
import { Link } from "react-router-dom";
import { getAllBlog } from "../API/BlogAPI";

const Blog = () => {
  const [blogs, setBlogs] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const postsPerPage = 8;

  // 🔹 Fetch API Data
  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        setLoading(true);
        const res = await getAllBlog();
        if (res?.status && res?.responseData) {
          setBlogs(res.responseData);
        } else {
          setBlogs([]);
        }
      } catch (error) {
        console.error("Error fetching blogs:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchBlogs();
  }, []);

  // Pagination Logic
  const indexOfLast = currentPage * postsPerPage;
  const indexOfFirst = indexOfLast - postsPerPage;
  const currentPosts = blogs.slice(indexOfFirst, indexOfLast);
  const totalPages = Math.ceil(blogs.length / postsPerPage);

  // 🔹 Loading Spinner
  if (loading) {
    return (
      <div className="min-h-full bg-gray-50">
        <Breadcrumb title="Blog" path="Blog" />
        <div className="flex justify-center items-center h-96">
          <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-theme2"></div>
        </div>
      </div>
    );
  }

  return (
    <>
      <Breadcrumb title="Blog" path="Blog" />

      <section className="py-12 container mx-auto px-4">
        <div className="grid md:grid-cols-3 lg:grid-cols-4 grid-cols-1 gap-8">
          {currentPosts.map((post) => (
            <Link
              to={`/blog/${post.Id}`}
              key={post.Id}
              className="bg-white rounded-2xl shadow-md hover:shadow-lg transition-shadow duration-300 overflow-hidden group"
            >
              <div className="overflow-hidden">
                <img
                  src={post.Image}
                  alt={post.Title}
                  className="w-full h-56 object-cover transform transition-transform duration-300 group-hover:scale-105"
                />
              </div>
              <div className="p-4">
                <p className="text-xs text-contentcolor mb-2">
                  {new Date(post.EntDt).toLocaleDateString("en-US", {
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                  })}
                </p>
                <h3 className="text-lg font-semibold text-darktext transition-colors duration-300 group-hover:text-theme2">
                  {post.Title}
                </h3>
                <Link className="text-sm text-theme2 pt-2" to={`/blog/${post.Id}`}>
                  Read More
                </Link>
              </div>
            </Link>
          ))}
        </div>

        {/* Pagination */}
        {blogs.length > postsPerPage && (
          <div className="flex justify-center mt-10 space-x-2">
            <button
              className="px-3 py-2 rounded bg-gray-100 text-contentcolor disabled:opacity-50"
              onClick={() => setCurrentPage(currentPage - 1)}
              disabled={currentPage === 1}
            >
              &lt;
            </button>

            {Array.from({ length: totalPages }, (_, i) => (
              <button
                key={i + 1}
                onClick={() => setCurrentPage(i + 1)}
                className={`px-3 py-2 rounded ${currentPage === i + 1
                  ? "bg-theme2 text-white"
                  : "bg-gray-100 text-contentcolor hover:border border-theme2"
                  }`}
              >
                {i + 1}
              </button>
            ))}

            <button
              className="px-3 py-2 rounded bg-gray-100 text-contentcolor disabled:opacity-50"
              onClick={() => setCurrentPage(currentPage + 1)}
              disabled={currentPage === totalPages}
            >
              &gt;
            </button>
          </div>
        )}
      </section>
    </>
  );
};

export default Blog;
